<template>
  <div id="Prerequisites">
    <v-expansion-panels focusable  class="px-2">
      <v-expansion-panel  class="mt-4 "  >
        <v-expansion-panel-header class="light-blue--text text--darken-4" >
          <v-layout row align-center>
            <v-icon color="green" v-if="hasCompletedAllPrerequisites">mdi-check-circle</v-icon>
            <v-icon color="red" v-else>mdi-check-circle</v-icon>
            <v-icon color="blue darken-3 " class="ml-2">mdi-text-box-multiple</v-icon>
            <span class="ml-2 blue--text text--darken-3 font-weight-medium">Prerequisites</span>
          </v-layout>

        </v-expansion-panel-header>
        <v-expansion-panel-content  class="mt-3 px-0 mx-0 pb-0 elevation-0" >

          <!-- Required Courses -->
          <v-card v-if="savedSchool.required_courses[0] === 0 && savedSchool.optional_courses_group[0] === 0 && savedSchool.required_category_courses[0] === 0"  flat>
            <v-card-text class="px-0 pt-3 pb-1 text-center">
                <span>Please visit the school website for prerequisite details</span>
            </v-card-text>
          </v-card>
          <v-card v-if="savedSchool.required_courses[0] !== 0 || savedSchool.optional_courses_group[0] !== 0 || savedSchool.required_category_courses[0] !== 0 " class="innerCardCover elevation-0" style="borderRadius:5px" >
            <v-layout v-if="!hasCompletedAllPrerequisites" justify-center class="red pb-2">
              <span class="white--text text-center mt-2">Required Prerequisites Pending</span>
            </v-layout>
            <v-layout v-if="hasCompletedAllPrerequisites" justify-center class="green pb-2">
              <span class="white--text text-center mt-2">Required Prerequisites Completed</span>
            </v-layout>

            <!--  Courses -->
            <v-expansion-panels v-if="savedSchool.required_courses[0] !== 0" class="px-2 elevation-0" >
              <v-expansion-panel  class="mt-3 elevation-0"  >
                <v-expansion-panel-header class="elevation-0">
                  <v-layout row align-center>
                    <v-icon v-if="usersRemaingingPrerequisites.length === 0" class="mr-1" color="green" small >mdi-check-circle</v-icon>
                    <v-icon v-else class="mr-1" color="red" small >mdi-check-circle</v-icon>
                    <span class="">Courses</span>
                    <span v-if="usersRemaingingPrerequisites.length > 0" class="caption font-weight-light ml-1 red--text">( {{usersRemaingingPrerequisites.length}} pending )</span>
                  </v-layout>
                </v-expansion-panel-header>
                <v-expansion-panel-content    id="secondaryButtonShadow">


                    <v-container pt-0 px-0 pb-0>
                      <v-list two-line class="pt-0 pb-0 " flat :ripple="false">
                        <v-list-item-group :ripple="false" >
                          <template ripple="false" v-for="(requiredCourse, index) in savedSchool.required_courses" >
                            <v-list-item :key="requiredCourse.id" class="pl-1 " :ripple="false" >

                                <v-list-item-content class="py-2">
                                  <v-list-item-title class="light-blue--text text--darken-3 labelCreateSpace">
                                    <v-layout align-center>
                                        <v-icon v-if="hasCompletedCourse(requiredCourse)" color="green" small class="mr-1">mdi-check-circle</v-icon>
                                        <v-icon v-else color="red" small class="mr-1">mdi-check-circle</v-icon>
                                        {{ requiredCourse.course_name }}
                                      </v-layout>
                                    </v-list-item-title>
                                    <v-list-item-subtitle  v-if="requiredCourse.lab[0] !== 'N/A'"  class="text--primary font-weight-light pl-5" >
                                    <span class="">{{ requiredCourse.lab[0] }} </span>

                                  </v-list-item-subtitle>

                                  <v-list-item-subtitle  v-if="requiredCourse.credits !== '' && requiredCourse.credits !== undefined || requiredCourse.semester !== '' && requiredCourse.semester !== undefined " class="text--primary font-weight-light pl-5" >
                                    <span v-if="requiredCourse.credits !== ''">{{ requiredCourse.credits }} credits  <span v-if="requiredCourse.semester !== '' && requiredCourse.semester !== undefined " >or</span></span>
                                    <span v-if="requiredCourse.semester !== '' && requiredCourse.semester !== undefined " >  {{ requiredCourse.semester }} semester hrs</span>
                                    <span v-if="requiredCourse.quarter !== '' && requiredCourse.quarter !== undefined" > or {{ requiredCourse.quarter}} quarter hrs</span>
                                  </v-list-item-subtitle>
                                  <v-btn
                                    :disabled="busy"
                                    @click="forceValidateCourse(requiredCourse, 'course')"
                                    v-if="!hasOverideForCourse(requiredCourse, 'course')"
                                    class="bypass-btn"
                                    x-small
                                    outlined
                                    color="green"
                                  >Bypass</v-btn>
                                  <v-btn
                                    :disabled="busy"
                                    @click="forceValidateCourse(requiredCourse, 'course', false)"
                                    v-if="hasOverideForCourse(requiredCourse, 'course')"
                                    class="bypass-btn"
                                    x-small
                                    outlined
                                    color="red"
                                  >Remove Bypass</v-btn>
                                </v-list-item-content>


                            </v-list-item>


                            <v-divider
                              v-if="index + 1 < savedSchool.required_courses.length"
                              :key="index"
                              class="my-0 py-0"
                            ></v-divider>
                          </template>

                        </v-list-item-group>
                      </v-list>
                    </v-container>

                </v-expansion-panel-content>

              </v-expansion-panel>
            </v-expansion-panels>

            <!-- Optional Courses -->
            <v-expansion-panels v-if="savedSchool.optional_courses_group && savedSchool.optional_courses_group[0] !== 0"  class="mt-2 px-2" >
              <v-expansion-panel  class="mt-3 " >
                <v-expansion-panel-header >
                  <v-layout row align-center>
                    <v-icon v-if="(requiredOptionalCoursesCount === allOptionalCourses.length)" class="mr-1" color="green" small >mdi-check-circle</v-icon>
                    <v-icon v-else class="mr-1" color="red" small >mdi-check-circle</v-icon>
                    <span class="">Either Course(s) Required</span>
                    <span v-if="(savedSchool.optional_courses_group.length - allOptionalCourses.length) > 0" class="caption font-weight-light ml-1 red--text">( {{ savedSchool.optional_courses_group.length - allOptionalCourses.length }} pending )</span>
                  </v-layout>
                </v-expansion-panel-header>

                <v-expansion-panel-content  id="secondaryButtonShadow">


                  <v-card
                    v-for="(optionalCourse) in savedSchool.optional_courses_group" :key="optionalCourse.id"
                    class="  elevation-0 innerCardCover  mb-3" style="borderRadius:5px" outlined
                    >
                    <v-layout  class=" pl-4 pb-1 mt-2">
                      <span  class="mt-2  body-2 labelCreateSpace labelCreateSpace--s">
                        <v-icon color="green" v-if="checkOptionalCourseGroup(optionalCourse)" small class="mr-1">mdi-check-circle</v-icon>
                        <v-icon color="red" v-else small class="mr-1" >mdi-check-circle</v-icon>
                        {{optionalCourse.mininum_courses_completed}}
                        of the following course(s) need to be completed
                      </span>
                    </v-layout>
                    <v-card-text pt-2 class="pt-0 pb-0 ">
                      <v-list two-line class="pt-0 pb-0" >
                              <v-list-item-group  >

                                  <template v-for=" (course, index) in optionalCourse.options" >

                                  <v-list-item :key="course.id" class="pl-0 pt-0" >

                                      <v-list-item-content>
                                        <v-list-item-title class="light-blue--text text--darken-3">
                                          <v-layout align-center>{{ course.course_name }} </v-layout>
                                        </v-list-item-title>
                                        <v-list-item-subtitle  v-if="course.lab !== null && course.lab !== undefined" class="text--primary font-weight-light" >
                                          <span class="">{{ course.lab[0] }} </span>

                                        </v-list-item-subtitle>

                                        <v-list-item-subtitle  v-if="course.credits !== '' && course.credits !== undefined" class="text--primary font-weight-light" >
                                          <span >{{ course.credits }} credits  <span v-if="course.semester !== '' && course.semester !== undefined " >or</span></span>
                                          <span v-if="course.semester !== '' && course.semester !== undefined " >  {{ course.semester }} semester hrs</span>
                                          <span v-if="course.quarter !== '' && course.quarter !== undefined" > or {{ course.quarter}} quarter hrs</span>
                                        </v-list-item-subtitle>


                                      </v-list-item-content>



                                  </v-list-item>


                                    <v-divider
                                    v-if="index + 1 < optionalCourse.options.length"
                                    :key="index"
                                  ></v-divider>
                                </template>



                              </v-list-item-group>
                          </v-list>



                    </v-card-text>

                    <v-btn
                      :disabled="busy"
                      @click="forceValidateCourse(optionalCourse, 'optionalcourse')"
                      v-if="!hasOverideForCourse(optionalCourse, 'optionalcourse')"
                      class="bypass-btn"
                      x-small
                      outlined
                      color="green"
                    >Bypass</v-btn>
                    <v-btn
                      :disabled="busy"
                      @click="forceValidateCourse(optionalCourse, 'optionalcourse', false)"
                      v-if="hasOverideForCourse(optionalCourse, 'optionalcourse')"
                      class="bypass-btn"
                      x-small
                      outlined
                      color="red"
                    >Remove Bypass</v-btn>
                  </v-card>



                </v-expansion-panel-content>
              </v-expansion-panel >
            </v-expansion-panels>


            <!--  Course Category -->
            <v-expansion-panels  v-if="savedSchool.required_category_courses[0] !== 0"  class="mt-2 px-2">
              <v-expansion-panel class="mt-3 ">
                <v-expansion-panel-header >
                  <v-layout row align-center>
                    <v-icon v-if="(savedSchool.required_category_courses.length - usersRemaingingCourseCat.length) === 0" class="mr-1" color="green" small >mdi-check-circle</v-icon>
                    <v-icon v-else class="mr-1" color="red" small >mdi-check-circle</v-icon>
                    <span class="">Required Category</span>
                    <span  v-if="(savedSchool.required_category_courses.length - usersRemaingingCourseCat.length) > 0" class="caption font-weight-light ml-1 red--text">( {{savedSchool.required_category_courses.length - usersRemaingingCourseCat.length}} pending )</span>
                  </v-layout>
                </v-expansion-panel-header>
                <v-expansion-panel-content   id="secondaryButtonShadow">


                    <v-card v-for="requiredCourseCategory in savedSchool.required_category_courses" :key="requiredCourseCategory.id"  class="innerCardCover mb-3 elevation-0" style="borderRadius:5px" outlined>
                      <v-card-title  class="pa-0">
                          <v-layout  class="" ml-2 py-2>
                        <v-icon color="green" v-if="checkRequiredCourseCategory(requiredCourseCategory)" small class="">mdi-check-circle</v-icon>
                        <v-icon color="red" v-else small class="" >mdi-check-circle</v-icon>
                        <span class="subtitle-1 ml-1 mb-0 labelCreateSpace">{{ requiredCourseCategory.category.category_name }}</span>
                      </v-layout>

                      </v-card-title>
                      <v-divider  class="mt-1 mb-1"></v-divider>
                      <!-- CATEGORY CONDITIONS -->
                      <v-container class="pt-2 pb-2 pl-2">

                          <!-- TOTAL CREDITS COMPLETED -->
                          <v-layout
                            v-if="requiredCourseCategory.total_credits_completed !== '' && requiredCourseCategory.total_credits_completed !== undefined
                            && requiredCourseCategory.number_of_courses_completed === '' || requiredCourseCategory.number_of_courses_completed === undefined
                            && savedSchool.maximum_outstanding_courses_while_applying === '' && savedSchool.maximum_outstanding_courses_while_applying === undefined"
                            >
                            <span class="font-weight-light"><span class="font-weight-regular light-blue--text text--darken-3">{{requiredCourseCategory.total_credits_completed}} credits</span>   of {{requiredCourseCategory.category.category_name}} need to be completed</span>

                          </v-layout>
                          <v-divider
                            v-if="requiredCourseCategory.total_credits_completed !== '' && requiredCourseCategory.total_credits_completed !== undefined
                            &&  requiredCourseCategory.number_of_courses_completed === '' && requiredCourseCategory.number_of_courses_completed === undefined
                            && savedSchool.maximum_outstanding_courses_while_applying !== '' && savedSchool.maximum_outstanding_courses_while_applying !== undefined"
                            class="mt-1 mb-1"
                            ></v-divider>



                          <!-- TOTAL # OF COURSES COMPLETED -->
                          <v-layout v-if="requiredCourseCategory.number_of_courses_completed !== '' && requiredCourseCategory.number_of_courses_completed !== undefined">
                            <span class="font-weight-light"><span class="font-weight-regular  light-blue--text text--darken-3">{{requiredCourseCategory.number_of_courses_completed}} course(s)</span>   of {{requiredCourseCategory.category.category_name}} need to be completed</span>
                          </v-layout>
                          <v-divider v-if="requiredCourseCategory.number_of_courses_completed !== '' && requiredCourseCategory.number_of_courses_completed !== undefined" class="mt-1"></v-divider>

                          <!-- # OF COURSES COMPLETED WITH LAB -->
                          <v-layout v-if="requiredCourseCategory.courses_required_with_lab !== '' && requiredCourseCategory.courses_required_with_lab !== undefined">
                            <span class="font-weight-light"><span class="font-weight-regular  light-blue--text text--darken-3">{{requiredCourseCategory.courses_required_with_lab}} course(s)</span> of {{requiredCourseCategory.category.category_name}} need to be completed with <span class="font-weight-bold grey--text text--darken-3">lab</span></span>
                          </v-layout>
                          <v-divider v-if="requiredCourseCategory.courses_required_with_lab !== '' && requiredCourseCategory.courses_required_with_lab !== undefined" class="mt-1"></v-divider>





                      </v-container>
                      <v-card-actions class="py-1 ">
                        <v-btn block  class="elevation-0" color="primary" dark @click="requiredCourseCategoryDialog (requiredCourseCategory)">
                          View Courses
                        </v-btn>

                      </v-card-actions>
                      <v-btn
                        :disabled="busy"
                        @click="forceValidateCourse(requiredCourseCategory, 'category')"
                        v-if="!hasOverideForCourse(requiredCourseCategory, 'category')"
                        class="bypass-btn"
                        x-small
                        outlined
                        color="green"
                      >Bypass</v-btn>
                      <v-btn
                        :disabled="busy"
                        @click="forceValidateCourse(requiredCourseCategory, 'category', false)"
                        v-if="hasOverideForCourse(requiredCourseCategory, 'category')"
                        class="bypass-btn"
                        x-small
                        outlined
                        color="red"
                      >Remove Bypass</v-btn>
                    </v-card>

                </v-expansion-panel-content>
              </v-expansion-panel>

                  <v-dialog
                          v-model="showCoursesCategory"
                          scrollable
                          max-width="400"
                          height="100"
                          style="zIndex:2000"
                          persistent
                          >


                          <v-card v-if="loadedCategory !== null && loadedCategory.excluded_courses === undefined "  style="borderRadius:10px">
                              <v-card-title class="title grey lighten-2 text-xs-center">
                                {{loadedCategory.category.category_name}}
                              <v-spacer></v-spacer>
                              <v-icon @click="showCoursesCategory = false">mdi-close</v-icon>
                              </v-card-title>

                              <v-card-text class="text-xs-justify mt-2"  >
                                <v-layout v-for="course in loadedCategory.category.courses" :key="course.id">
                                  <span class="primary--text">{{course.course_name}}</span>
                                </v-layout>
                                <v-layout v-if="loadedCategory.included_courses.length >= 1" v-for="course in showCoursesCategory.included_courses" :key="course.id">
                                  <span class="primary--text">{{course.course_name}}</span>
                                </v-layout>
                              </v-card-text>
                          </v-card>

                          <!-- <v-card  v-if="loadedCategory !== null && loadedCategory.excluded_courses === undefined " style="borderRadius:10px">
                              <v-card-title class="title grey lighten-2 text-xs-center">
                                {{loadedCategory.category.category_name}} Courses
                              <v-spacer></v-spacer>
                              <v-icon @click="showCoursesCategory = null">mdi-close</v-icon>
                              </v-card-title>



                                      <v-card-text class="text-xs-justify" >
                                        <v-layout v-for="course in showCoursesCategory.category.courses" :key="course.id">
                                          <span>{{course.course_name}}</span>
                                        </v-layout>
                                        <v-layout v-if="showCoursesCategory.included_courses.length >= 1" v-for="course in showCoursesCategory.included_courses" :key="course.id">
                                          <span>{{course.course_name}}</span>
                                        </v-layout>
                                      </v-card-text>


                                </v-tabs>

                          </v-card> -->

                          <v-card  v-if="loadedCategory !== null && loadedCategory.excluded_courses !== undefined" style="borderRadius:10px">
                              <v-card-title class="title grey lighten-2 text-xs-center">
                                {{loadedCategory.category.category_name}}
                              <v-spacer></v-spacer>
                              <v-icon @click="showCoursesCategory = false">mdi-close</v-icon>
                              </v-card-title>


                                <v-tabs  grow fixed class="px-3 mt-4">
                                  <v-tab active-class="grey darken-3 white--text" style="marginLeft:0px;">
                                  Courses
                                  </v-tab>

                                  <v-tab v-if="loadedCategory.excluded_courses !== undefined && loadedCategory.excluded_courses.length >= 1" active-class="grey darken-3 white--text">
                                    Excluded Courses
                                  </v-tab>

                                  <v-tab-item>
                                      <v-card-text class="text-xs-justify" >
                                        <v-layout v-for="course in loadedCategory.category.courses" :key="course.id">
                                          <span class="primary--text">{{course.course_name}}</span>
                                        </v-layout>
                                        <v-layout v-if="showCoursesCategory.included_courses.length >= 1" v-for="course in showCoursesCategory.included_courses" :key="course.id">
                                          <span class="primary--text">{{course.course_name}}</span>
                                        </v-layout>
                                      </v-card-text>
                                  </v-tab-item>
                                  <v-tab-item>
                                    <v-layout v-if="loadedCategory.excluded_courses.length >= 1" v-for="course in loadedCategory.excluded_courses" :key="course.id">
                                        <v-card-text class="text-xs-justify" >
                                          <span class="red--text">{{course.course_name}}</span>
                                        </v-card-text>
                                        </v-layout>
                                  </v-tab-item>

                                </v-tabs>

                          </v-card>


                        </v-dialog>






            </v-expansion-panels>


          </v-card>


            <!-- Prerequisites CONDITION CARD -->
            <v-card v-if="savedSchool.required_courses[0] !== 0 || savedSchool.optional_courses_group[0] !== 0 || savedSchool.required_category_courses[0] !== 0 "
              class=" mt-5 mb-3 innerCardCover elevation-0 pb-2"
              style="borderRadius:5px"
              outlined
             >
              <v-layout justify-center class=" grey lighten-3 pb-2 ">
                  <span block flat class="mt-2 "> Prerequisite Conditions </span>
              </v-layout>
              <v-divider></v-divider>
              <v-card-text class="pt-1 px-2 pb-1">

                <!-- Grade Conditions -->
                <v-card
                  v-if="savedSchool.minimum_grade_course !== '' && savedSchool.minimum_grade_course !== undefined
                  || savedSchool.recommended_grade_course !== '' && savedSchool.recommended_grade_course !== undefined
                  || savedSchool.nomore_1_grade_below_b_minus === true && savedSchool.nomore_1_grade_below_b_minus!== undefined
                  || savedSchool.nomore_2_grades_below_c !== '' && savedSchool.nomore_2_grades_below_c!== undefined
                  || savedSchool.maximum_grades_below_c_minus !== '' && savedSchool.maximum_grades_below_c_minus !== undefined
                  || savedSchool.minimumGrade_C_required_specific_courses[0] !== 0"
                  class=" mt-4  mb-3 elevation-0" style="borderRadius:5px" outlined
                  >
                  <v-layout  class="   pb-2 pt-2 red align-center justify-center">
                    <span  class=" white--text font-weight-medium "> Grade Conditions </span>
                  </v-layout>
                  <v-card-text class="pt-2 pb-1">
                      <!-- MINIMUM GRADE REQUIRED FOR prerequisites -->
                    <v-layout v-if="savedSchool.minimum_grade_course !== '' && savedSchool.minimum_grade_course !== undefined"  >
                      <span class="font-weight-light black--text"> Minimum grade of  <span class="font-weight-medium blue--text text--darken-3">{{savedSchool.minimum_grade_course}}</span>  required for all prerequisites</span>
                    </v-layout>

                    <v-divider v-if="savedSchool.minimum_grade_course !== '' && savedSchool.minimum_grade_course !== undefined" class="mt-2 mb-2 "></v-divider>

                    <!-- MINIMUM GRADE RECOMMENDED FOR prerequisites -->
                    <v-layout v-if="savedSchool.recommended_grade_course !== '' && savedSchool.recommended_grade_course !== undefined" >
                      <span class="font-weight-light black--text"> Minimum grade of  <span class="font-weight-medium blue--text text--darken-3">{{savedSchool.recommended_grade_course}}</span>  recommended for all prerequisites</span>
                    </v-layout>

                    <v-divider v-if="savedSchool.recommended_grade_course !== '' && savedSchool.recommended_grade_course !== undefined" class="mt-2 mb-2 "></v-divider>

                    <!-- ONLY 1 PREREQUISTE COURSE BELOW GRADE B- ACCEPTED -->
                    <v-layout v-if="savedSchool.nomore_1_grade_below_b_minus === true && savedSchool.nomore_1_grade_below_b_minus!== undefined"  >
                      <span class="font-weight-light black--text"> Maximum of <span class="font-weight-medium blue--text text--darken-3">1</span> prerequisite(s) accepted below <span class="font-weight-medium blue--text text--darken-3">B- </span> </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.nomore_1_grade_below_b_minus === true && savedSchool.nomore_1_grade_below_b_minus !== undefined" class="mt-2 mb-2 "></v-divider>

                    <!-- MAXIMUM # OF prerequisites WITH GRADE C  -->
                    <v-layout v-if="savedSchool.nomore_2_grades_below_c !== '' && savedSchool.nomore_2_grades_below_c!== undefined" >
                      <span class="font-weight-light black--text"> Maximum of  <span class="font-weight-medium blue--text text--darken-3">{{savedSchool.nomore_2_grades_below_c}}</span> prerequisites accepted with grade <span class="font-weight-medium blue--text text--darken-3">C</span>  </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.nomore_2_grades_below_c !== '' && savedSchool.nomore_2_grades_below_c !== undefined" class="mt-2 mb-2 "></v-divider>

                    <!-- MAXIMUM # OF COURSES WITH GRADE C- OR BELOW  -->
                    <v-layout v-if="savedSchool.maximum_grades_below_c_minus !== '' && savedSchool.maximum_grades_below_c_minus !== undefined" >
                      <span class="font-weight-light black--text"> Maximum of  <span class="font-weight-medium blue--text text--darken-3">{{savedSchool.maximum_grades_below_c_minus}}</span> courses accepted with grade <span class="font-weight-medium blue--text text--darken-3">C-</span> or below  </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.maximum_grades_below_c_minus !== '' && savedSchool.maximum_grades_below_c_minus !== undefined" class="mt-2 mb-2 "></v-divider>

                    <!-- MINIMUM GRADE OF C REQUIRED FOR FOLLOWING prerequisites -->
                    <v-layout v-if="savedSchool.minimumGrade_C_required_specific_courses[0] !== 0" column class="pb-2 mt-2 ">
                      <v-layout >
                        <p class="font-weight-light mt-2 mb-0 black--text">Minimum grade of <span class="font-weight-medium blue--text text--darken-3">C </span>required for the following prerequisites:</p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.minimumGrade_C_required_specific_courses" :key="course.id" class="mt-3 ">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                          <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>
                  </v-card-text>
                </v-card>

                <!-- TIME FRAME CONDITIONS -->
                <v-card
                    v-if="savedSchool.maximum_years_courses_completed !== '' && savedSchool.maximum_years_courses_completed !== undefined
                    || savedSchool.maximum_years_science_courses_completed!== '' && savedSchool.maximum_years_science_courses_completed !== undefined
                    || savedSchool.maximum_years_math_courses_completed!== '' && savedSchool.maximum_years_math_courses_completed !== undefined
                    || savedSchool.number_of_credits_completed_within_3_years!== '' && savedSchool.number_of_credits_completed_within_3_years !== undefined
                    || savedSchool.number_of_credits_completed_within_5_years !== '' && savedSchool.number_of_credits_completed_within_5_years !== undefined
                    || savedSchool.specific_classes_completed_within_3years[0] !== 0
                    || savedSchool.specific_classes_completed_within_5years[0] !== 0
                    || savedSchool.specific_classes_completed_within_7years[0] !== 0
                    || savedSchool.specific_classes_completed_within_8years[0] !== 0
                    || savedSchool.specific_classes_completed_within_10years[0] !== 0
                    || savedSchool.no_courses_5years_unless_healthcare_experience && savedSchool.no_courses_5years_unless_healthcare_experience !== undefined
                    || savedSchool.preference_completed_courses_within_5years !== '' && savedSchool.preference_completed_courses_within_5years !== undefined"
                    class=" mt-4  mb-3 elevation-0" style="borderRadius:5px" outlined
                  >
                  <v-layout  class="  pb-2 pt-2 red justify-center">
                    <span  class=" white--text font-weight-medium"> Timeframe Conditions </span>
                  </v-layout>
                  <v-card-text class="pt-1">
                    <!-- All prerequisites must be completed within  -->
                    <v-layout v-if="savedSchool.maximum_years_courses_completed !== '' && savedSchool.maximum_years_courses_completed !== undefined" >
                      <span class="font-weight-light black--text"> All prerequisites must be completed within  <span class="font-weight-medium blue--text text--darken-3"> {{savedSchool.maximum_years_courses_completed}} year(s)</span>  </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.maximum_years_courses_completed !== '' && savedSchool.maximum_years_courses_completed !== undefined" class="mt-2 mb-2 "></v-divider>

                    <!-- SCIENCE prerequisites must be completed within  -->
                    <v-layout v-if="savedSchool.maximum_years_science_courses_completed!== '' && savedSchool.maximum_years_science_courses_completed !== undefined" >
                      <span class="font-weight-light black--text"> Science prerequisites must be completed within  <span class="font-weight-medium blue--text text--darken-3"> {{savedSchool.maximum_years_science_courses_completed}} year(s)</span>  </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.maximum_years_science_courses_completed !== '' && savedSchool.maximum_years_science_courses_completed !== undefined" class="mt-2 mb-2 "></v-divider>

                    <!-- MATH prerequisites must be completed within  -->
                    <v-layout v-if="savedSchool.maximum_years_math_courses_completed!== '' && savedSchool.maximum_years_math_courses_completed !== undefined" >
                      <span class="font-weight-light black--text"> Math prerequisites must be completed within  <span class="font-weight-medium blue--text text--darken-3"> {{savedSchool.maximum_years_math_courses_completed}} year(s)</span>  </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.maximum_years_math_courses_completed !== '' && savedSchool.maximum_years_math_courses_completed !== undefined" class="mt-2 mb-2 "></v-divider>

                    <!-- x credits need to be completed within 3 YEARS -->
                    <v-layout v-if="savedSchool.number_of_credits_completed_within_3_years!== '' && savedSchool.number_of_credits_completed_within_3_years !== undefined" >
                      <span class="font-weight-light black--text">   <span class="font-weight-bold grey--text text--darken-2"> {{savedSchool.number_of_credits_completed_within_3_years}} credits </span> need to be completed within <span class="font-weight-medium blue--text text--darken-3">3 years</span>  </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.number_of_credits_completed_within_3_years !== '' && savedSchool.number_of_credits_completed_within_3_years !== undefined" class="mt-2 mb-2"></v-divider>

                    <!-- x credits need to be completed within 5 YEARS  -->
                    <v-layout v-if="savedSchool.number_of_credits_completed_within_5_years !== '' && savedSchool.number_of_credits_completed_within_5_years !== undefined" >
                      <span class="font-weight-light black--text">   <span class="font-weight-bold grey--text text--darken-2"> {{savedSchool.number_of_credits_completed_within_5_years}} credits </span> need to be completed within <span class="font-weight-medium blue--text text--darken-3"> 5 years</span>  </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.number_of_credits_completed_within_5_years !== '' && savedSchool.number_of_credits_completed_within_5_years !== undefined" class="mt-2 mb-2 "></v-divider>

                    <!-- Specific courses that need to be completed within 3 years -->
                    <v-layout v-if="savedSchool.specific_classes_completed_within_3years[0] !== 0" column class="pb-2 mt-1 ">
                      <v-layout >
                        <p class="font-weight-light black--text mt-2 mb-0 ">Following prerequisites must be completed within <span class="font-weight-medium blue--text text--darken-3">3 years: </span> </p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.specific_classes_completed_within_3years" :key="course.id" class="mt-3">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>

                    <!-- Specific courses that need to be completed within 5 years -->
                    <v-layout v-if="savedSchool.specific_classes_completed_within_5years[0] !== 0" column class="pb-2 mt-1 ">
                      <v-layout >
                        <p class="font-weight-light black--text mt-1 mb-0 ">Following prerequisites must be completed within <span class="font-weight-medium blue--text text--darken-3">5 years: </span> </p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.specific_classes_completed_within_5years" :key="course.id" class="mt-3">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>

                    <!-- Specific courses that need to be completed within 7 years -->
                    <v-layout v-if="savedSchool.specific_classes_completed_within_7years[0] !== 0" column class="pb-2 mt-1 ">
                      <v-layout >
                        <p class="font-weight-light black--text mt-1 mb-0 ">Following prerequisites must be completed within <span class="font-weight-medium blue--text text--darken-3">7 years: </span> </p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.specific_classes_completed_within_7years" :key="course.id" class="mt-3">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>

                    <!-- Specific courses that need to be completed within 8 years -->
                    <v-layout v-if="savedSchool.specific_classes_completed_within_8years[0] !== 0" column class="pb-2 mt-1 ">
                      <v-layout >
                        <p class="font-weight-light black--text mt-1 mb-0 ">Following prerequisites must be completed within <span class="font-weight-medium blue--text text--darken-3">8 years: </span> </p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.specific_classes_completed_within_8years" :key="course.id" class="mt-3">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>

                    <!-- Specific courses that need to be completed within 10 years -->
                    <v-layout v-if="savedSchool.specific_classes_completed_within_10years[0] !== 0" column class="pb-2 mt-1 ">
                      <v-layout >
                        <p class="font-weight-light black--text mt-1 mb-0 ">Following prerequisites must be completed within <span class="font-weight-medium blue--text text--darken-3">10 years: </span> </p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.specific_classes_completed_within_10years" :key="course.id" class="mt-3">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>

                    <!-- No courses older than 5 years accepted, unless employed full time in healthcare since completion of courses -->
                    <v-layout v-if="savedSchool.no_courses_5years_unless_healthcare_experience && savedSchool.no_courses_5years_unless_healthcare_experience !== undefined" >
                      <span class="font-weight-light black--text">  No courses older than <span class="font-weight-medium blue--text text--darken-3">5 years</span> accepted, unless <span class="font-weight-bold grey--text text--darken-2">employed full time in healthcare </span> since completion of courses    </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.no_courses_5years_unless_healthcare_experience  && savedSchool.no_courses_5years_unless_healthcare_experience !== undefined" class="mt-2 mb-2 "></v-divider>

                    <!-- Preference given if prerequisites completed within x YEARS  -->
                    <v-layout v-if="savedSchool.preference_completed_courses_within_5years !== '' && savedSchool.preference_completed_courses_within_5years !== undefined" >
                      <span class="font-weight-light black--text">   Preference given if courses completed within<span class="font-weight-medium blue--text text--darken-3"> {{savedSchool.preference_completed_courses_within_5years}} year(s) </span>  </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.preference_completed_courses_within_5years !== '' && savedSchool.preference_completed_courses_within_5years !== undefined" class="mt-2 mb-2"></v-divider>
                  </v-card-text>
                </v-card>

                <!-- ALL PREREQUISTES MUST BE COMPLETED BEFORE APPLYING -->
                <v-card
                  v-if="savedSchool.prerequistes_completed_before_applying"
                  class=" mt-4  mb-3 elevation-0" style="borderRadius:5px" outlined
                  >
                  <v-layout  class=" px-2 pb-2 pt-2 red justify-center">
                    <span  class=" text-center white--text font-weight-medium"> All Prerequisites must be completed before applying</span>
                  </v-layout>

                </v-card>

                <!-- PREREQUISTE COMPLETION CONDITIONS -->
                <v-card
                  v-if="
                  savedSchool.Prerequisites_completed_before_applying
                  || savedSchool.minimum_completed_prereqs_before_applying !== '' && savedSchool.minimum_completed_prereqs_before_applying !== undefined
                  || savedSchool.specific_courses_completed_before_application[0] !== 0
                  || savedSchool.minimum_science_credits_completed !== '' && savedSchool.minimum_science_credits_completed !== undefined
                  || savedSchool.number_credits_completed_before_applying!== '' && savedSchool.number_credits_completed_before_applying !== undefined"
                  class=" mt-4  mb-3 elevation-0" style="borderRadius:5px" outlined
                  >
                  <v-layout  class="pb-2 pt-2 red justify-center">
                    <span  class=" white--text font-weight-medium"> Prerequisite Completion Conditions </span>
                  </v-layout>
                  <v-card-text class="pt-2">

                  <!-- All prerequisites must be completed before applying -->
                  <v-layout v-if="savedSchool.Prerequisites_completed_before_applying" >
                      <span class="font-weight-light black--text">All prerequisites must be completed before applying</span>
                  </v-layout>
                  <v-divider v-if="savedSchool.Prerequisites_completed_before_applying && savedSchool.Prerequisites_completed_before_applying !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- Atleast x number of prerequisites must be completed before applying -->
                  <v-layout v-if="savedSchool.minimum_completed_prereqs_before_applying !== '' && savedSchool.minimum_completed_prereqs_before_applying !== undefined" >
                      <span class="font-weight-light black--text ">At least <span class="font-weight-medium blue--text text--darken-3">{{savedSchool.minimum_completed_prereqs_before_applying}} prerequisites</span> must be completed before applying</span>
                  </v-layout>
                  <v-divider v-if="savedSchool.minimum_completed_prereqs_before_applying && savedSchool.minimum_completed_prereqs_before_applying !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- Minimum number of SCIENCE credits that need to be completed before applying -->
                  <v-layout v-if="savedSchool.minimum_science_credits_completed !== '' && savedSchool.minimum_science_credits_completed !== undefined" >
                    <span class="font-weight-light black--text"> <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.minimum_science_credits_completed}} Science</span> credits must be completed before applying </span>
                  </v-layout>
                  <v-divider v-if="savedSchool.minimum_science_credits_completed && savedSchool.minimum_science_credits_completed !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- Total number of credits that need to be completed before applying  -->
                  <v-layout v-if="savedSchool.number_credits_completed_before_applying!== '' && savedSchool.number_credits_completed_before_applying !== undefined" >
                    <span class="font-weight-light black--text"> <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.number_credits_completed_before_applying}} credits</span> must be completed before applying </span>
                  </v-layout>
                  <v-divider v-if="savedSchool.number_credits_completed_before_applying && savedSchool.number_credits_completed_before_applying !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- The following prerequisites must be completed before applying -->
                  <v-layout v-if="savedSchool.specific_courses_completed_before_application[0] !== 0" column class="pb-2 mt-1 ">
                    <v-layout >
                      <p class="font-weight-light black--text mt-1 mb-0 "> Following prerequisites must be completed before applying: </p>
                    </v-layout>
                    <v-layout column v-for=" course in savedSchool.specific_courses_completed_before_application" :key="course.id" class="mt-3">
                      <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                      <v-layout>
                        <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                        <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                        <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                      </v-layout>
                      <v-divider class="mt-2"></v-divider>
                    </v-layout>

                  </v-layout>


                  </v-card-text>
                </v-card>

                <!-- PENDING PREREQUISTE CONDITIONS -->
                <v-card
                  v-if="savedSchool.courses_in_progress_during_application
                  || savedSchool.specific_courses_in_progress_while_applying[0] !== 0
                  || savedSchool.maximum_outstanding_courses_while_applying !== '' && savedSchool.maximum_outstanding_courses_while_applying !== undefined
                  || savedSchool.first_time_applicant_minimum_number_courses_pending_before_applying !== '' && savedSchool.first_time_applicant_minimum_number_courses_pending_before_applying!== undefined
                  || savedSchool.minimum_grade_pending_course !== '' && savedSchool.minimum_grade_pending_course !== undefined
                  || savedSchool.maximum_outstanding_sciences_courses_while_applying !== '' && savedSchool.maximum_outstanding_sciences_courses_while_applying !== undefined
                  || savedSchool.maximum_outstanding_nonsciences_courses_while_applying !== '' && savedSchool.maximum_outstanding_nonsciences_courses_while_applying !== undefined
                  || savedSchool.maximum_credits_pending_while_applying !== '' && savedSchool.maximum_credits_pending_while_applying !== undefined
                  || savedSchool.outstanding_courses_completed_date !== '' && savedSchool.outstanding_courses_completed_date !== undefined
                  || savedSchool.outstanding_courses_completed_by_semester !== '' && savedSchool.outstanding_courses_completed_by_semester !== undefined
                  || savedSchool.outstanding_sciences_courses_completed_by_semester !== '' && savedSchool.outstanding_sciences_courses_completed_by_semester !== undefined"
                  class=" mt-4  mb-3 elevation-0" style="borderRadius:5px" outlined
                  >
                  <v-layout  class="  pb-2 pt-2 red justify-center">
                    <span  class=" white--text font-weight-medium"> Pending Prerequisite Conditions </span>
                  </v-layout>
                  <v-card-text class="pt-1">

                    <!-- Prerequisites can be in progress at time of application -->
                    <v-layout
                      v-if="savedSchool.courses_in_progress_during_application
                      && (savedSchool.specific_courses_in_progress_while_applying[0] === 0 || savedSchool.specific_courses_in_progress_while_applying === undefined)
                      && (savedSchool.maximum_outstanding_courses_while_applying === '' || savedSchool.maximum_outstanding_courses_while_applying === undefined)
                      && (savedSchool.first_time_applicant_minimum_number_courses_pending_before_applying === '' || savedSchool.first_time_applicant_minimum_number_courses_pending_before_applying === undefined)
                      && (savedSchool.minimum_grade_pending_course === '' || savedSchool.minimum_grade_pending_course === undefined)
                      && (savedSchool.maximum_outstanding_sciences_courses_while_applying === '' || savedSchool.maximum_outstanding_sciences_courses_while_applying === undefined)
                      && (savedSchool.maximum_outstanding_nonsciences_courses_while_applying === '' || savedSchool.maximum_outstanding_nonsciences_courses_while_applying === undefined)
                      && (savedSchool.maximum_credits_pending_while_applying === '' || savedSchool.maximum_credits_pending_while_applying === undefined)"

                      >
                      <span class="font-weight-light black--text">Prerequisites can be in progress at time of application </span>

                    </v-layout>
                    <v-divider v-if="savedSchool.courses_in_progress_during_application
                      && (savedSchool.specific_courses_in_progress_while_applying[0] === 0 || savedSchool.specific_courses_in_progress_while_applying === undefined)
                      && (savedSchool.maximum_outstanding_courses_while_applying === '' || savedSchool.maximum_outstanding_courses_while_applying === undefined)
                      && (savedSchool.first_time_applicant_minimum_number_courses_pending_before_applying === '' || savedSchool.first_time_applicant_minimum_number_courses_pending_before_applying === undefined)
                      && (savedSchool.minimum_grade_pending_course === '' || savedSchool.minimum_grade_pending_course === undefined)
                      && (savedSchool.maximum_outstanding_sciences_courses_while_applying === '' || savedSchool.maximum_outstanding_sciences_courses_while_applying === undefined)
                      && (savedSchool.maximum_outstanding_nonsciences_courses_while_applying === '' || savedSchool.maximum_outstanding_nonsciences_courses_while_applying === undefined)
                      && (savedSchool.maximum_credits_pending_while_applying === '' || savedSchool.maximum_credits_pending_while_applying === undefined)"  class="mt-2 mb-2 "></v-divider>

                    <!-- Only the following prerequisites can be in progress while applying -->
                    <v-layout v-if="savedSchool.specific_courses_in_progress_while_applying[0] !== 0" column class="pb-2 mt-1 ">
                      <v-layout >
                        <p class="font-weight-light black--text mt-1 mb-0 "> Only the following prerequisites can be in progress while applying: </p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.specific_courses_in_progress_while_applying" :key="course.id" class="mt-3">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>


                  <!-- Only x number of prerequisites can be pending while applying -->
                  <v-layout v-if="savedSchool.maximum_outstanding_courses_while_applying !== '' && savedSchool.maximum_outstanding_courses_while_applying !== undefined">
                    <span class="font-weight-light black--text">Maximum of <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.maximum_outstanding_courses_while_applying}} prerequisite(s)</span>  can be pending while applying</span>
                  </v-layout>
                  <v-divider v-if="savedSchool.maximum_outstanding_courses_while_applying && savedSchool.maximum_outstanding_courses_while_applying !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- First time applicant can have x number of prerequisites pending while applying -->
                  <v-layout v-if="savedSchool.first_time_applicant_minimum_number_courses_pending_before_applying !== '' && savedSchool.first_time_applicant_minimum_number_courses_pending_before_applying!== undefined" >
                    <span class="font-weight-light black--text">First time applicant can have <span class="blue--text text--darken-3 font-weight-medium"> {{savedSchool.first_time_applicant_minimum_number_courses_pending_before_applying}} prerequisite(s)</span> pending while applying</span>
                  </v-layout>
                  <v-divider v-if="savedSchool.first_time_applicant_minimum_number_courses_pending_before_applying && savedSchool.first_time_applicant_minimum_number_courses_pending_before_applying !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- Minimum grade required for pending prerequisites -->
                  <v-layout v-if="savedSchool.minimum_grade_pending_course !== '' && savedSchool.minimum_grade_pending_course !== undefined" >
                    <span class="font-weight-light black--text">Minimum grade of <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.minimum_grade_pending_course}} </span>  required for pending prerequisites</span>
                  </v-layout>
                  <v-divider v-if="savedSchool.minimum_grade_pending_course && savedSchool.minimum_grade_pending_course !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- Only x number of SCIENCE prerequisites can be pending while applying -->
                  <v-layout v-if="savedSchool.maximum_outstanding_sciences_courses_while_applying !== '' && savedSchool.maximum_outstanding_sciences_courses_while_applying !== undefined" >
                    <span class="font-weight-light black--text">Maximum of <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.maximum_outstanding_sciences_courses_while_applying}} SCIENCE prerequisites</span>  can be pending while applying</span>
                  </v-layout>
                  <v-divider v-if="savedSchool.maximum_outstanding_sciences_courses_while_applying && savedSchool.maximum_outstanding_sciences_courses_while_applying !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- Only x number of NON-SCIENCE prerequisites can be pending while applying -->
                  <v-layout v-if="savedSchool.maximum_outstanding_nonsciences_courses_while_applying !== '' && savedSchool.maximum_outstanding_nonsciences_courses_while_applying !== undefined" >
                    <span class="font-weight-light black--text">Maximum of <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.maximum_outstanding_nonsciences_courses_while_applying}} NON-SCIENCE prerequisites</span>  can be pending while applying</span>
                  </v-layout>
                  <v-divider v-if="savedSchool.maximum_outstanding_nonsciences_courses_while_applying && savedSchool.maximum_outstanding_nonsciences_courses_while_applying !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- Only x credits can be pending while applying -->
                  <v-layout v-if="savedSchool.maximum_credits_pending_while_applying !== '' && savedSchool.maximum_credits_pending_while_applying !== undefined" >
                    <span class="font-weight-light black--text">Maximum of<span class="blue--text text--darken-3 font-weight-medium ml-1">{{savedSchool.maximum_credits_pending_while_applying}} credits</span>  can be pending while applying</span>
                  </v-layout>
                  <v-divider v-if="savedSchool.maximum_credits_pending_while_applying && savedSchool.maximum_credits_pending_while_applying !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- Pending prerequisites must be completed by date -->
                  <v-layout v-if="savedSchool.outstanding_courses_completed_date !== '' && savedSchool.outstanding_courses_completed_date !== undefined" >
                    <span class="font-weight-light black--text">Pending prerequisites must be completed by <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.outstanding_courses_completed_date | removeTimeFromDate | moment("MMMM Do")}} </span> </span>
                  </v-layout>
                  <v-divider v-if="savedSchool.outstanding_courses_completed_date && savedSchool.outstanding_courses_completed_date !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- Pending prerequisites must be completed by Semester -->
                  <v-layout v-if="savedSchool.outstanding_courses_completed_by_semester !== '' && savedSchool.outstanding_courses_completed_by_semester !== undefined" >
                    <span class="font-weight-light black--text">Pending prerequisites must be completed by end of <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.outstanding_courses_completed_by_semester}} semester </span> </span>
                  </v-layout>
                  <v-divider v-if="savedSchool.outstanding_courses_completed_by_semester && savedSchool.outstanding_courses_completed_by_semester !== undefined" class="mt-2 mb-2 "></v-divider>

                  <!-- Pending SCIENCE prerequisites must be completed by date -->
                  <v-layout v-if="savedSchool.outstanding_sciences_courses_completed_by_semester !== '' && savedSchool.outstanding_sciences_courses_completed_by_semester !== undefined" >
                    <span class="font-weight-light black--text">Pending <span class="font-weight-bold grey--text text--darken-2  ">SCIENCE </span>prerequisites must be completed by end of <span class="blue--text text--darken-3 font-weight-medium">{{savedSchool.outstanding_sciences_courses_completed_by_semester}} semester </span> </span>
                  </v-layout>
                  <v-divider v-if="savedSchool.outstanding_sciences_courses_completed_by_semester && savedSchool.outstanding_sciences_courses_completed_by_semester !== undefined" class="mt-2 mb-2 "></v-divider>

                  </v-card-text>
                </v-card>

                <!-- OTHER PREREQUISTE CONDITIONS -->
                <v-card
                  v-if="savedSchool.either_course_credits_completed[0] !== 0
                  || savedSchool.specific_courses_completed_4_year_college[0] !== 0
                  || savedSchool.courses_waived_with_bachelors[0] !== 0"
                  class=" mt-4  mb-3 elevation-0" style="borderRadius:5px" outlined
                  >
                  <v-layout  class=" pb-2 pt-2 red justify-center">
                    <span class=" white--text font-weight-medium"> Other Prerequisite Conditions </span>
                  </v-layout>
                  <v-card-text pt-2 class="pt-0">

                    <!-- Following prerequisites must be completed at 4 year college -->
                    <v-layout v-if="savedSchool.specific_courses_completed_4_year_college[0] !== 0" column class="pb-2 mt-1 ">
                      <v-layout >
                        <p class="font-weight-light  black--text mt-1 mb-0 "> Following prerequisites must be completed at 4 year college: </p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.specific_courses_completed_4_year_college" :key="course.id" class="mt-3">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.min_credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>

                    <!-- Following prerequisites are waived with completion of Bachelors Degree -->
                    <v-layout v-if="savedSchool.courses_waived_with_bachelors[0] !== 0" column class="pb-2 mt-1 ">
                      <v-layout >
                        <p class="font-weight-light black--text mt-1 mb-0 "> Following prerequisites are waived with completion of Bachelors Degree: </p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.courses_waived_with_bachelors" :key="course.id" class="mt-3">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.min_credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>

                  </v-card-text>
                </v-card>

                <!-- COMMUNITY COLLEGE COURSE CONDITIONS -->
                <v-card
                  v-if="savedSchool.community_college_courses_accepted && savedSchool.community_college_courses_accepted !== undefined
                  || savedSchool.community_college_courses_accepted_regionally_accredited  && savedSchool.community_college_courses_accepted_regionally_accredited !== undefined
                  "
                  class=" mt-4  mb-3 "
                  outlined
                  flat
                  >
                  <v-layout  class=" px-2 justify-center pr-1 pb-2 pt-2">
                    <span class=" green--text text-center font-weight-medium"> Community College courses accepted if school is regionally accredited </span>
                  </v-layout>

                </v-card>

                <!-- ONLINE/WEB BASED COURSE CONDITIONS -->
                <v-card
                  v-if="savedSchool.online_courses_accepted && savedSchool.online_courses_accepted !== undefined
                  || savedSchool.online_courses_lab_accepted && savedSchool.online_courses_lab_accepted !== undefined
                  || savedSchool.online_science_courses_accepted && savedSchool.online_science_courses_accepted !== undefined
                  || savedSchool.online_nonscience_courses_accepted && savedSchool.online_nonscience_courses_accepted !== undefined
                  || savedSchool.online_credits_accepted_specific_courses[0] !== 0
                  || savedSchool.online_courses_accepted_regionally_accredited  && savedSchool.online_courses_accepted_regionally_accredited !== undefined"
                  class=" mt-4  mb-3"
                  outlined
                  flat
                  >
                  <v-layout  class=" px-2 justify-center  pb-2 pt-2 ">
                    <span  class="green--text text-center font-weight-medium"> Online courses accepted if school is regionally accredited</span>
                  </v-layout>
                  <v-card-text
                    v-if="savedSchool.online_credits_accepted_specific_courses[0] !== 0
                    || savedSchool.online_nonscience_courses_accepted && savedSchool.online_nonscience_courses_accepted !== undefined
                    || savedSchool.online_courses_lab_accepted && savedSchool.online_courses_lab_accepted !== undefined"
                      class="pt-1 pb-1"
                    >

                    <!-- Online credits accepted for specific courses -->
                    <v-layout v-if="savedSchool.online_credits_accepted_specific_courses[0] !== 0" column class="pb-2 mt-1 ">
                      <v-layout >
                        <p class="font-weight-light black--text mt-1 mb-0 ">For Following Prerequisites:</p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.online_credits_accepted_specific_courses" :key="course.id" class="mt-3">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>

                    <!-- Online NON-SCIENCE courses accepted -->
                    <v-layout v-if="savedSchool.online_nonscience_courses_accepted && savedSchool.online_nonscience_courses_accepted !== undefined" >
                      <span class="font-weight-light black--text"> Only <span class="font-weight-bold grey--text text--darken-2">NON-SCIENCE</span> courses accepted </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.online_nonscience_courses_accepted && savedSchool.online_nonscience_courses_accepted !== undefined" class="mt-2 mb-2 "></v-divider>

                    <!-- Online courses lab component accepted -->
                  <v-layout v-if="savedSchool.online_courses_lab_accepted && savedSchool.online_courses_lab_accepted !== undefined"  mt-1>
                    <span class="font-weight-light black--text">  <span class="font-weight-bold grey--text text--darken-2">Online lab </span> component accepted for courses </span>
                  </v-layout>
                  <v-divider v-if="savedSchool.online_courses_lab_accepted && savedSchool.online_courses_lab_accepted !== undefined" class="mt-2 mb-2 "></v-divider>

                  </v-card-text>
                </v-card>

                <!-- ADVANCED PLACEMENT PREREQUISTE CONDITIONS -->
                <v-card
                  v-if="savedSchool.ap_credits_accepted && savedSchool.ap_credits_accepted !== undefined
                  || savedSchool.ap_science_credits_accepted && savedSchool.ap_science_credits_accepted !== undefined
                  || savedSchool.ap_nonscience_credits_accepted && savedSchool.ap_nonscience_credits_accepted !== undefined
                  || savedSchool.ap_credits_accepted_specific_courses[0] !== 0
                  || savedSchool.ap_credits_accepted_transcript && savedSchool.ap_credits_accepted_transcript!== undefined"
                  class=" mt-4  mb-3 "
                  flat
                  outlined
                  >
                  <v-layout  class=" px-2 justify-center pb-2 pt-2 ">
                    <span  class=" green--text text-center font-weight-medium"> AP credits accepted if they appear on official transcript</span>
                  </v-layout>
                  <v-card-text
                    v-if="savedSchool.ap_nonscience_credits_accepted && savedSchool.ap_nonscience_credits_accepted !== undefined
                    || savedSchool.ap_credits_accepted_specific_courses[0] !== 0"
                      class="pt-0 pb-1"
                    >
                    <!-- AP credits accepted for specific courses-->
                    <v-layout v-if="savedSchool.ap_credits_accepted_specific_courses[0] !== 0" column class="pb-2 mt-1 ">
                      <v-layout >
                        <p class="font-weight-light black--text mt-1 mb-0 ">For Following Prerequisites:</p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.ap_credits_accepted_specific_courses" :key="course.id" class="mt-3">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>
                    <!-- AP NON-SCIENCE credits/courses accepted -->
                    <v-layout v-if="savedSchool.ap_nonscience_credits_accepted && savedSchool.ap_nonscience_credits_accepted !== undefined"  mt-2>
                      <span class="font-weight-light black--text"> Only <span class="font-weight-bold grey--text text--darken-2">NON-SCIENCE</span> credits accepted </span>
                    </v-layout>
                    <v-divider v-if="savedSchool.ap_nonscience_credits_accepted && savedSchool.ap_nonscience_credits_accepted !== undefined" class="mt-2 mb-2 "></v-divider>

                  </v-card-text>
                </v-card>

                <!-- PASS/FAIL CONDITIONS -->
                <v-card
                  v-if="savedSchool.pass_fail_grade_accepted"
                  class=" mt-4  mb-3 "
                  outlined
                  flat
                  >
                  <v-layout  class=" px-2 justify-center pb-2 pt-2">
                    <span  class="green--text text-center font-weight-medium"> Pass/Fail Grade Accepted</span>
                  </v-layout>
                  <v-card-text
                    v-if="savedSchool.pass_fail_grade_accepted_courses !== null && savedSchool.pass_fail_grade_accepted_courses !== undefined && savedSchool.pass_fail_grade_accepted_courses[0] !== 0"
                    class="pt-2 pb-1"
                    >

                    <v-layout  column class="pb-2 mt-1">


                        <v-layout class="pb-2 " > <span class="font-weight-light black--text mb-0">For Following Prerequisites:</span></v-layout>
                        <v-layout column v-for="course in savedSchool.pass_fail_grade_accepted_courses" :key="course .id" class="mt-1 ml-2">
                          <v-layout row align-center >
                            <span class=" blue--text text--darken-3 pl-3">{{course.course_name}}</span>
                          </v-layout>

                          <v-divider class="mt-2"></v-divider>
                        </v-layout>


                    </v-layout>


                  </v-card-text>
                </v-card>

                <!-- CLEP(College Level Examination Program) -->
                <v-card
                  v-if="savedSchool.clep_accepted && savedSchool.clep_accepted !== undefined
                  || savedSchool.clep_accepted_specific_courses[0] !== 0"
                  class=" mt-4  mb-3 "
                  outlined
                  flat
                  >
                  <v-layout  class=" px-2 justify-center pb-2 pt-2 ">
                    <span  class=" green--text text-center font-weight-medium"> CLEP credits accepted</span>
                  </v-layout>
                  <v-card-text
                    v-if="savedSchool.clep_accepted_specific_courses[0] !== 0"
                      class="pt-2"
                    >
                    <!-- CLEP for specific courses -->
                    <v-layout v-if="savedSchool.clep_accepted_specific_courses[0] !== 0" column class="pb-2 mt-1 ">
                      <v-layout >
                        <p class="font-weight-light black--text mt-1 mb-0 ">For Following Prerequisites:</p>
                      </v-layout>
                      <v-layout column v-for=" course in savedSchool.clep_accepted_specific_courses" :key="course.id" class="mt-3">
                        <v-layout row align-center pl-3><span class=" blue--text text--darken-3 ">{{course.course_name}}</span> <span v-if="course.lab !== null && course.lab !== undefined" class="caption grey--text ml-1">{{course.lab[0]}}</span> </v-layout>
                        <v-layout>
                          <span v-if="course.credits !== '' && course.credits !== undefined" class="grey--text">{{course.credits}} credits</span>
                          <span v-if="course.semester !== '' && course.semester!== undefined" class="grey--text"> - {{course.semester}} semester hrs</span>
                          <span v-if="course.quarter !== '' && course.quarter!== undefined" class="grey--text"> - {{course.quarter}} quarter hrs</span>
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                      </v-layout>

                    </v-layout>


                  </v-card-text>
                </v-card>



                <!-- Community College Courses NOT accepted -->
                <v-card
                    v-if="!savedSchool.community_college_courses_accepted || savedSchool.community_college_courses_accepted === undefined
                  && !savedSchool.community_college_courses_accepted_regionally_accredited  || savedSchool.community_college_courses_accepted_regionally_accredited === undefined
                  "
                  class=" mt-4  mb-3 "
                  outlined
                  flat
                  >
                  <v-layout  class=" px-2   pb-2 pt-2  align-center justify-center">
                    <span  class=" text-center  red--text font-weight-medium"> Community College courses NOT accepted </span>
                  </v-layout>

                </v-card>

                <!-- Online Courses NOT accepted -->
                <v-card
                  v-if="!savedSchool.online_courses_accepted || savedSchool.online_courses_accepted === undefined
                  &&  !savedSchool.online_courses_lab_accepted || savedSchool.online_courses_lab_accepted === undefined
                  &&  !savedSchool.online_science_courses_accepted || savedSchool.online_science_courses_accepted === undefined
                  &&  !savedSchool.online_nonscience_courses_accepted || savedSchool.online_nonscience_courses_accepted === undefined
                  &&  savedSchool.online_credits_accepted_specific_courses[0] === 0
                  &&  !savedSchool.online_courses_accepted_regionally_accredited  || savedSchool.online_courses_accepted_regionally_accredited === undefined"
                  class="mt-4"
                  flat
                  outlined
                  >
                  <v-layout class=" px-2 justify-center pb-2 pt-2 ">
                    <span  class="red--text font-weight-medium"> Online courses NOT accepted </span>
                  </v-layout>

                </v-card>

                <!-- AP credits NOT accepted -->
                <v-card
                  v-if="!savedSchool.ap_credits_accepted || savedSchool.ap_credits_accepted === undefined
                  && !savedSchool.ap_science_credits_accepted || savedSchool.ap_science_credits_accepted === undefined
                  && !savedSchool.ap_nonscience_credits_accepted || savedSchool.ap_nonscience_credits_accepted === undefined
                  && savedSchool.ap_credits_accepted_specific_courses[0] === 0
                  && !savedSchool.ap_credits_accepted_transcript || savedSchool.ap_credits_accepted_transcript === undefined"
                  class="mt-4"
                  outlined
                  flat
                  >
                  <v-layout class=" px-2 justify-center pb-2 pt-2 ">
                    <span  class="red--text font-weight-medium"> AP credits NOT accepted</span>
                  </v-layout>
                </v-card>

                <!-- Pass/Fail Grade NOT accepted -->
                <v-card
                  v-if="!savedSchool.pass_fail_grade_accepted || savedSchool.pass_fail_grade_accepted === undefined "
                  class="mt-4"
                  outlined
                  flat
                  >
                    <v-layout  class=" px-2 justify-center  pb-2 pt-2 ">
                    <span  class="red--text font-weight-medium"> Pass/Fail Grade NOT accepted</span>
                  </v-layout>

                </v-card>

                <!-- CLEP credits NOT accepted -->
                <v-card
                    v-if="!savedSchool.clep_accepted || savedSchool.clep_accepted === undefined
                  && savedSchool.clep_accepted_specific_courses[0] === 0"
                  class="mt-4"
                  flat
                  outlined
                  >
                  <v-layout  class=" px-2 justify-center  pb-2 pt-2 ">
                    <span  class=" text-center red--text font-weight-medium"> CLEP credits NOT accepted</span>
                  </v-layout>
                </v-card>

                <!-- Prerequisite Notes -->
                    <v-card  v-if="savedSchool.prerequistesNotes" outlined class=" mt-4 mb-4">
                      <v-layout align-center justify-center class=" pb-1" >
                        <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                        <span class="font-weight-light align-center"> Additional Notes </span>
                      </v-layout>
                      <v-divider></v-divider>
                      <v-card-text class="text-center">
                        <span>{{savedSchool.prerequistesNotes}}</span>
                      </v-card-text>
                    </v-card>

              </v-card-text>
            </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import userMixins from '@/mixins/usersmixin'
  import checkPrerequisitesMixin from '@/mixins/requirementchecks/checkprerequisitesmixin'

  export default {
    mixins: [userMixins,checkPrerequisitesMixin],
    props: ['savedSchool'],
    data() {
      return {
        showCoursesCategory: false,
        loadedCategory: null,
      }
    },

  }
</script>

<style scoped>
.v-expansion-panel::before {
   box-shadow: 0 10px 20px -10px rgba(0,0,0,.19)  !important;
}
.innerCardCover {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  border-radius: 5px;
  padding: 0;
  margin-top: 12px;
}

.bypass-btn {
  display: inline-flex;
  font-size: 8px;
  position: absolute;
  top: 10px;
  right: 5px;
}
@media (max-width: 960px) {
  .labelCreateSpace {
    max-width: calc(100% - 80px);
    white-space: inherit;
  }
  .labelCreateSpace--s {
    max-width: calc(100% - 95px);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/RequirementTracker/Prerequisites.vue